module.exports = __webpack_public_path__ + "media/dashboard/assets/images/empty_invoice-d1b580a77098cf2f28ff4c7a40591c9e.svg";